"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBreakpoint = void 0;
const material_1 = require("@mui/material");
function useBreakpoint(breakpoint = "sm") {
    return (0, material_1.useMediaQuery)((theme) => theme.breakpoints.down(breakpoint));
}
exports.useBreakpoint = useBreakpoint;
//# sourceMappingURL=useBreakpoint.js.map